export const GATEWAY_MODULE = {
  WIDGETS: [
    {
      categoryType: 'hotspotCarousel',
      widgetCategoryTitle: '常用',
      isShow: 'DISPLAY',
      sort: 2,
      bottomSpacing: 0,
      circulateType: 'NORMAL',
      presentationType: 'TWO_IMENSIONAL',
      slideType: 'MANUAL',
      swipeTime: 1,
      carouselInfos: [
        {
          picUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/gw-search-3.jpg',
          imageHeight: 45,
          interactionTypeInfo: [
            {
              interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
              interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_首页',
              interactionTypePath: 'gateway',
              mouseDownX: 3,
              mouseDownY: 4,
              elementPositionX: 126,
              elementPositionY: 44
            },
            {
              interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
              interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_搜索',
              interactionTypePath: 'search',
              mouseDownX: 130,
              mouseDownY: 2,
              elementPositionX: 373,
              elementPositionY: 44
            }
          ]
        }
      ],
      interactionTypeInfo: [
        {
          picUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/gw-search-2.jpg'
        }
      ]
    },
    {
      categoryType: 'TCG',
      widgetCategoryTitle: '常用',
      isShow: 'DISPLAY',
      sort: 3,
      bottomSpacing: 0,
      circulateType: 'LOOP',
      presentationType: 'THREE_IMENSIONAL',
      slideType: 'AUTOMATIC',
      swipeTime: 4,
      interactionTypeInfo: [
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_无',
          pageUrl:
            'https://amazon-front.woaap.com/landingpage/AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0_GS APP NC Demo',
          picUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/tcg-1.jpg'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_促销定制页',
          interactionTypePath: 'todayDeal',
          pageUrl: '',
          picUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/tcg-dotd.jpg'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_二级活动页',
          interactionTypePath: '',
          selectedPage: {
            pageId: 'AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0',
            pageName: 'Leadership Demo RC',
            pagePath:
              'https://globalstore.amazon.cn/landingpage/AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0_GS APP Prime Demo'
          },
          pageUrl: '',
          picUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/tcg-prime-1.jpg'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_二级活动页',
          interactionTypePath: '',
          selectedPage: {
            pageId: 'AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0',
            pageName: 'Leadership Demo NC',
            pagePath:
              'https://globalstore.amazon.cn/landingpage/AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0_GS APP NC Demo'
          },
          pageUrl: '',
          picUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/tcg-nc-1.jpg'
        }
      ]
    },
    {
      categoryType: 'shortcut',
      widgetCategoryTitle: '导航',
      isShow: 'DISPLAY',
      sort: 4,
      bottomSpacing: 0,
      textColor: 'rgba(214, 3, 3, 1)',
      fillType: 'PICURL',
      fillBackgroundColor:
        'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/scb.jpg',
      numberRows: 'TWO',
      interactionTypeInfo: [
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_促销定制页',
          interactionTypePath: 'todayDeal',
          navigationPicUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/dd-1.gif',
          navigationName: '今日特惠'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_二级活动页',
          interactionTypePath: '',
          selectedPage: {
            pageId: 'AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0',
            pageName: 'Leadership Demo RC',
            pagePath:
              'https://globalstore.amazon.cn/landingpage/AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0_GS APP Prime Demo'
          },
          navigationPicUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/dd-2.gif',
          navigationName: '领券中心'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_二级活动页',
          interactionTypePath: '',
          selectedPage: {
            pageId: 'AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0',
            pageName: 'Leadership Demo NC',
            pagePath:
              'https://globalstore.amazon.cn/landingpage/AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0_GS APP NC Demo'
          },
          navigationPicUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/dd-3.gif',
          navigationName: '热卖榜单'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
          interactionTypePath: 'productList',
          conditionMatch: 'CoQ10',
          displayName: 'Q10辅酶',
          navigationPicUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/dd-4.gif',
          navigationName: '新品发布'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
          interactionTypePath: 'productList',
          conditionMatch: 'move free chondroitin',
          displayName: 'Move Free 绿瓶',
          navigationPicUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/dd-5.gif',
          navigationName: '奥莱折扣'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
          interactionTypePath: 'productList',
          conditionMatch: 'waterpik',
          displayName: '洁碧水牙线',
          navigationPicUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/dd-6.gif',
          navigationName: '赚佣金'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
          interactionTypePath: 'productList',
          conditionMatch: '女装服饰',
          displayName: '潮流服饰',
          navigationPicUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/dd-7.gif',
          navigationName: '潮流服饰'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
          interactionTypePath: 'productList',
          conditionMatch: '鞋靴',
          displayName: '时尚鞋靴',
          navigationPicUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/dd-8.gif',
          navigationName: '时尚鞋靴'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
          interactionTypePath: 'productList',
          conditionMatch: '护肤精华',
          displayName: '美容护肤',
          navigationPicUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/dd-9.gif',
          navigationName: '美容护肤'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
          interactionTypePath: 'productList',
          conditionMatch: '硬盘',
          displayName: '数码电子',
          navigationPicUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/dd-10.gif',
          navigationName: '数码电子'
        }
      ]
    },
    {
      categoryType: 'storeAnnouncement',
      widgetCategoryTitle: '常用',
      isShow: 'DISPLAY',
      sort: 5,
      bottomSpacing: 0,
      ceilingType: 'NOT_CEILING',
      textColor: '#D60303',
      scrollSpeed: 1700,
      cornerIcon:
        'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/gg.png',
      interactionTypeInfo: [
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_二级活动页',
          interactionTypePath: '',
          selectedPage: {
            pageId: 'AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0',
            pageName: 'Leadership Demo RC',
            pagePath:
              'https://globalstore.amazon.cn/landingpage/AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0_GS APP Prime Demo'
          },
          pageUrl: '',
          announcementContent: '畅享优惠券！3个月福利月月领！'
        },
        {
          interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
          interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_二级活动页',
          interactionTypePath: '',
          selectedPage: {
            pageId: 'AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0',
            pageName: 'Leadership Demo NC',
            pagePath:
              'https://globalstore.amazon.cn/landingpage/AAHKV2X7AFYLW#zh-CN#GSApp#LandingPage#0_GS APP NC Demo'
          },
          pageUrl: '',
          announcementContent: '新人专属特权！速戳来领！'
        }
      ]
    },
    {
      categoryType: 'hotspotCarousel',
      widgetCategoryTitle: '常用',
      isShow: 'DISPLAY',
      sort: 6,
      bottomSpacing: 12,
      circulateType: 'NORMAL',
      presentationType: 'TWO_IMENSIONAL',
      slideType: 'MANUAL',
      swipeTime: 1,
      carouselInfos: [
        {
          picUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/atf-gif.gif',
          imageHeight: 375,
          interactionTypeInfo: [
            {
              interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
              interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
              interactionTypePath: 'productList',
              conditionMatch: 'galison',
              displayName: 'Galison拼图',
              mouseDownX: 12,
              mouseDownY: 10,
              elementPositionX: 367,
              elementPositionY: 130
            },
            {
              interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
              interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
              interactionTypePath: 'productList',
              conditionMatch: 'Meta',
              displayName: 'Meta Quest3',
              mouseDownX: 13,
              mouseDownY: 134,
              elementPositionX: 131,
              elementPositionY: 255
            },
            {
              interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
              interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
              interactionTypePath: 'productList',
              conditionMatch: 'ECCO',
              displayName: 'ECCO',
              mouseDownX: 143,
              mouseDownY: 162,
              elementPositionX: 250,
              elementPositionY: 262
            },
            {
              interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
              interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
              interactionTypePath: 'productList',
              conditionMatch: 'Mammut',
              displayName: 'Mammut',
              mouseDownX: 263,
              mouseDownY: 163,
              elementPositionX: 373,
              elementPositionY: 262
            },
            {
              interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
              interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
              interactionTypePath: 'productList',
              conditionMatch: 'The North Face',
              displayName: 'The North Face',
              mouseDownX: 14,
              mouseDownY: 264,
              elementPositionX: 181,
              elementPositionY: 370
            },
            {
              interactionTypeId1: 'AAHKV2X7AFYLW#zh-CN_跳转内部页面',
              interactionTypeId2: 'AAHKV2X7AFYLW#zh-CN_商品列表',
              interactionTypePath: 'productList',
              conditionMatch: '4090',
              displayName: '发烧级显卡',
              mouseDownX: 202,
              mouseDownY: 265,
              elementPositionX: 365,
              elementPositionY: 371
            }
          ]
        }
      ],
      interactionTypeInfo: [
        {
          picUrl:
            'https://m.media-amazon.com/images/G/28/HUHE/New_GS_APP/Homepage/Demo/atf-gif.gif'
        }
      ]
    }
  ],
  NOT_LOGGED_IN_DATA: [
    {
      categoryType: 'imageBanner',
      widgetCategoryTitle: '图片广告',
      isShow: 'DISPLAY',
      sort: 23,
      bottomSpacing: 12,
      layoutType: 'ENDTISE_TILED',
      spacing: 10,
      height: 175,
      interactionTypeInfo: [
        {
          interactionTypeId1: '3240#zh-CN_跳转内部页面',
          interactionTypeId2: '3240#zh-CN_个人中心',
          interactionTypePath: 'yourAccount',
          picUrl:
            'https://ka-sit.etocdn.cn/840/2023-09-15/840_20230915174903098316798592.jpg'
        }
      ]
    }
  ]
};
